"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface ServiceItem {
  name: string;
  description: string;
  image?: {
    src: string;
    srcset: string;
    sizes: string;
    alt: string;
  };
}
const services: ServiceItem[] = [{
  name: "Remodelling",
  description: "Complete room updates, kitchen and bath overhauls, and layout changes.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_remodeling_work.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_remodeling_work.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_remodeling_work.png-wvc-sizes",
    alt: "Remodelling work in progress"
  }
}, {
  name: "Tiling",
  description: "Floor and wall tile, kitchen backsplashes, and walk-in shower surrounds.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_tiling_expertise.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_tiling_expertise.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_tiling_expertise.png-wvc-sizes",
    alt: "Tile installation"
  }
}, {
  name: "Painting",
  description: "Interior and exterior prep, trim painting, and durable protective coats.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_painting_finish.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_painting_finish.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_painting_finish.png-wvc-sizes",
    alt: "Interior painting finish"
  }
}, {
  name: "Vinyl Flooring",
  description: "Waterproof luxury vinyl plank and tile installation with clean edge transitions.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_vinyl_flooring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_vinyl_flooring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_vinyl_flooring.png-wvc-sizes",
    alt: "Vinyl flooring installation"
  }
}, {
  name: "Laminate Flooring",
  description: "Scratch-resistant laminate planks fitted over quiet, level underlayment.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_laminate_flooring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_laminate_flooring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_laminate_flooring.png-wvc-sizes",
    alt: "Laminate flooring installation"
  }
}, {
  name: "Hardwood Flooring",
  description: "Solid and engineered hardwood fitting, spot board repairs, and refinishing.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_hardwood_flooring.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_hardwood_flooring.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_hardwood_flooring.png-wvc-sizes",
    alt: "Hardwood flooring"
  }
}, {
  name: "Plumbing",
  description: "Leak fixes, fixture replacements, water line hookups, and bathroom pipe routing.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_plumbing_systems.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_plumbing_systems.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_plumbing_systems.png-wvc-sizes",
    alt: "Plumbing repairs and installation"
  }
}, {
  name: "Power Washing",
  description: "High-pressure wash for siding, walkways, concrete driveways, and decks.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_power_washing.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_power_washing.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_power_washing.png-wvc-sizes",
    alt: "Power washing surface cleaning"
  }
}, {
  name: "Carpentry",
  description: "Framing, baseboard and casing trim, door installation, and custom shelving.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_carpentry_service.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_carpentry_service.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_carpentry_service.png-wvc-sizes",
    alt: "Carpentry work"
  }
}, {
  name: "Drywall Repairs and Installation",
  description: "Hole patching, water damage repair, hanging new sheets, taping, and sanding smooth.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_drywall_repair.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_drywall_repair.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/ablaze_drywall_repair.png-wvc-sizes",
    alt: "Drywall installation and repair"
  }
}, {
  name: "Snow Removal",
  description: "Seasonal clearing of driveways, sidewalks, stairs, and parking pads."
}];
export default function Services() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section id="services" className="bg-card text-card-foreground border-y border-border py-14 md:py-20 lg:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mb-10 md:mb-14 text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-normal leading-[1.15] tracking-tight text-foreground mb-3">
            Services
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-sans leading-relaxed">
            Trade work handled directly by our crew for homeowners and properties across Dumfries, Virginia and the surrounding area.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0 transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0 motion-reduce:opacity-100"}`}>
          {services.map((service, index) => {
          const bookingHref = `/BookAppointmentPage?service=${encodeURIComponent(service.name)}`;
          return <div key={service.name} data-index={index} className="py-5 border-b border-border flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div className="flex items-start gap-4 min-w-0">
                  {service.image ? <div className="w-14 h-14 shrink-0 rounded-xs border border-border overflow-hidden bg-muted">
                      <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} className="w-full h-full object-cover" loading="lazy" />
                    </div> : null}
                  <div className="min-w-0">
                    <h3 className="text-lg font-serif font-normal text-foreground leading-snug">
                      {service.name}
                    </h3>
                    <p className="text-sm text-muted-foreground font-sans mt-1 leading-normal">
                      {service.description}
                    </p>
                  </div>
                </div>

                <div className="shrink-0 self-start sm:self-center">
                  <Link to={bookingHref} className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-primary hover:text-primary/80 transition-colors py-2 px-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-xs">
                    <span>Book this</span>
                    <ArrowRight className="size-3.5" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}